module.exports = __webpack_public_path__ + "static/media/RedDiamond.fd04eb15.svg";